export default __webpack_public_path__ + "static/media/background-light-blue.3f090495.jpg";